// src/auth/SignUpScreen.jsx
import { useState } from "react";
import TermsModal   from "../legal/TermsModal";
import PrivacyModal from "../legal/PrivacyModal";
import {
  pageStyle, cardStyle, logoStyle, headingStyle,
  labelStyle, inputStyle, errorStyle, btnPrimaryStyle, linkBtnStyle, googleFont,
} from "./authStyles";

export default function SignUpScreen({ onSwitch, onSuccess }) {
  const [email,        setEmail]        = useState("");
  const [password,     setPassword]     = useState("");
  const [confirm,      setConfirm]      = useState("");
  const [termsChecked, setTermsChecked] = useState(false);
  const [error,        setError]        = useState("");
  const [busy,         setBusy]         = useState(false);
  const [showTerms,    setShowTerms]    = useState(false);
  const [showPrivacy,  setShowPrivacy]  = useState(false);

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm)  { setError("Passwords do not match."); return; }
    if (password.length < 8)   { setError("Password must be at least 8 characters."); return; }
    if (!termsChecked)         { setError("Please agree to the Terms of Service to continue."); return; }

    setBusy(true);
    try {
      const res  = await fetch("/.netlify/functions/wc-auth-signup", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Sign up failed."); setBusy(false); return; }
      // Auto-record terms acceptance since they checked the box
      try {
        await fetch("/.netlify/functions/wc-auth-accept-terms", {
          method:  "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${data.token}` },
          body:    JSON.stringify({ email }),
        });
      } catch { /* non-fatal */ }
      onSuccess({ ...data, user: { ...data.user, agreedToTerms: true } });
    } catch {
      setError("Network error. Please try again.");
    }
    setBusy(false);
  };

  return (
    <div style={pageStyle}>
      {googleFont}
      {showTerms   && <TermsModal   readOnly onClose={() => setShowTerms(false)}   onAccept={() => { setTermsChecked(true); setShowTerms(false); }} />}
      {showPrivacy && <PrivacyModal onClose={() => setShowPrivacy(false)} />}

      <div style={cardStyle}>
        <button onClick={() => onSwitch("landing")} style={{ ...linkBtnStyle, marginBottom: 16 }}>← Back to home</button>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={logoStyle}>✍️</div>
          <h1 style={headingStyle}>Create Account</h1>
          <p style={{ color: "#8b949e", fontSize: 13, margin: 0 }}>Start with 1 free evaluation</p>
        </div>

        <form onSubmit={handleSignUp} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={labelStyle}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min. 8 characters" required style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Confirm Password</label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Re-enter password" required style={inputStyle} />
          </div>

          <label style={{ display: "flex", gap: 10, alignItems: "flex-start", cursor: "pointer" }}>
            <input type="checkbox" checked={termsChecked} onChange={e => setTermsChecked(e.target.checked)}
              style={{ marginTop: 2, accentColor: "#388bfd", flexShrink: 0 }} />
            <span style={{ fontSize: 12, color: "#8b949e", lineHeight: 1.6 }}>
              I am 13 or older (or a parent/guardian), and I agree to Writing Coach's{" "}
              <button type="button" onClick={() => setShowTerms(true)}   style={{ ...linkBtnStyle, color: "#388bfd", fontSize: 12 }}>Terms of Service</button>
              {" "}and{" "}
              <button type="button" onClick={() => setShowPrivacy(true)} style={{ ...linkBtnStyle, color: "#388bfd", fontSize: 12 }}>Privacy Policy</button>.
            </span>
          </label>

          {error && <div style={errorStyle}>⚠ {error}</div>}
          <button type="submit" disabled={busy || !termsChecked} style={btnPrimaryStyle(busy || !termsChecked)}>
            {busy ? "Creating account…" : "Create Account →"}
          </button>
        </form>

        <div style={{ marginTop: 16, textAlign: "center", fontSize: 13, color: "#8b949e" }}>
          Already have an account?{" "}
          <button onClick={() => onSwitch("login")} style={{ ...linkBtnStyle, color: "#388bfd", fontWeight: 700 }}>Sign in</button>
        </div>
      </div>
    </div>
  );
}
